var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headway"},[_c('span',[_c('i',{class:['ra-icon--bell', { active: _vm.widgetActive }]})])])}
var staticRenderFns = []

export { render, staticRenderFns }